// extracted by mini-css-extract-plugin
export default {"buttonIcon":"PreconfigActionButton_buttonIcon__pHYC4"};